import { FormattedDurationOptions, formattedDuration } from 'ui-format-utils';
import { useEffect, useState } from 'react';
import { useInterval } from 'usehooks-ts';
import { BasicBookingFragment } from 'drycut-graphql';

type Props = {
  booking?: BasicBookingFragment;
} & FormattedDurationOptions;

export function BookingWaitingTime({ booking, ...options }: Props): JSX.Element {
  const [time, setTime] = useState<number>(booking?.waitingTime || 0);
  const [shouldStop, setShouldStop] = useState<boolean>(false);

  useInterval(
    () => {
      if (time <= 0) {
        setShouldStop(true);
      } else {
        setTime((prevTime) => prevTime - 1);
      }
    },
    shouldStop ? null : 1000,
  );

  // If we get an update from the server, we stop the interval and update the time. This will happen
  // only when the component is under a RealTimeStoreProvider.
  useEffect(() => {
    const updatedTime = booking?.waitingTime;

    if (typeof updatedTime === 'number') {
      setTime(updatedTime);
      setShouldStop(false);
    }
  }, [booking]);

  return <span data-time={time}>{formattedDuration(time, options)}</span>;
}
